import React from 'react';
import { Box, Typography } from 'housecall-ui';
import LocationOnIcon from 'housecall-ui/dist/IconsAndImages/Icons/LocationOn';

import { AutocompletePrediction } from '../../api/googlePlaces';

export const AutoCompleteRenderOption = (props: AutocompletePrediction) => {
  return (
    <Box my={1} display="flex" alignItems="center">
      <Box mr={1} display="flex" alignItems="center">
        <LocationOnIcon size="small" color="secondary" />
      </Box>
      <Box mr={1}>
        <Typography variant="body2">{props.structured_formatting.main_text}</Typography>
      </Box>
      <Typography variant="caption">{props.structured_formatting.secondary_text}</Typography>
    </Box>
  );
};
